import { Component, Input, Output } from '@angular/core';
import { StateOfCarService } from '@app/shared/services/state-of-car.service';
import { EventEmitter } from '@angular/core';
import { DateService } from '@app/shared/services/date.service';
declare var UIkit: any;

@Component({
  selector: 'app-state-of-car-informations',
  templateUrl: './state-of-car-informations.component.html',
  styleUrls: ['./state-of-car-informations.component.scss']
})
export class StateOfCarInformationsComponent {

  public state: any = {};
  public states: any = [];
  public loading: boolean = true;

  @Input() id: number = 0;
  @Input() relatedStates: any = [];
  @Input() status: number = 0;
  @Output() changed = new EventEmitter();

  constructor(
    private stateOfCarService: StateOfCarService,
    private dateService: DateService
  ) { }

  ngOnChanges() {
    if (this.id !== 0) {
      this.loading = true;
      this.stateOfCarService.getStateOfCarById(this.id).then((res) => {
        res = this.dateService.convertToLocal(res);
        this.state = res;
        this.sortStates();
        this.loading = false;
      });
    }
  }

  sortStates() {
    if (this.relatedStates.length === 0) {
      return;
    }
    let sorted = false;
    let expectedStates = this.relatedStates.length + 1;
    let part = 1;

    this.states = [];
    while (sorted === false) {
      if (this.state.part === part) {
        this.states.push(this.state);
        part += 1;
      }
      this.relatedStates.forEach((related) => {
        if (related.part === part) {
          this.states.push(related);
          part += 1;
        }
      });
      if (this.states.length === expectedStates) {
        sorted = true;
      }
    }
  }

  updateStatus() {
    if (this.relatedStates.length > 0) {
      let promises: Array<any> = [];

      this.states.forEach((state) => {
        promises.push(this.stateOfCarService.updateSinisterState(state.id, this.status));
      });
      Promise.all(promises).then(() => {
        this.changed.emit(this.status);
        UIkit.modal('#manager-state-of-car-informations').hide();
      });
    } else {
      this.stateOfCarService.updateSinisterState(this.id, this.status).then((res) => {
        this.changed.emit(this.status);
        UIkit.modal('#manager-state-of-car-informations').hide();
      });
    }
  };

}
